<template>
    <modal :id="id" :loading="loading" :saveing="saveing" @shown="shown" @ok="save" @cancel="cancel">
        <span slot="modal-title">社團活動</span>
        <div role="tablist">
            <b-button class="mb-1" block v-b-toggle.accordion-1>基本資料</b-button>
            <b-collapse id="accordion-1" visible accordion="my-accordion" role="tabpanel">

                <div class="card mb-1">
                    <div class="card-body row">
                        <div class="col-md-6 col-sm-12">
                            <form-input v-model="vm.SYear" id="SYear" label="學年度" type="number" required></form-input>
                        </div>
                        <div class="col-md-6 col-sm-12">
                            <form-select v-model="vm.Semester" id="Semester" label="學期" required>
                                <div is="option" value="u">上</div>
                                <div is="option" value="d">下</div>
                            </form-select>
                        </div>
                        <div class="col-md-4 col-sm-12">
                            <div class="form-group">
                                <span class="text-danger">*</span>
                                <label for="No">活動編號</label>
                                <div class="input-group">
                                    <input id="No" type="number" class="form-control" v-model="vm.No">
                                    <div class="input-group-append">
                                        <b-button variant="primary" @click="getActive()">帶入</b-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4 col-sm-12">
                            <form-input v-model="vm.Name" id="Name" label="名稱" type="text" required></form-input>
                        </div>
                        <div class="col-md-4 col-sm-12">
                            <form-select v-model="vm.Property" id="Property" label="活動性質" required>
                                <slot name="property"></slot>
                            </form-select>
                        </div>
                    </div>
                </div>

                <div class="card mb-1">
                    <div class="card-header">
                        活動時間
                    </div>
                    <div class="card-body row">
                        <div class="col-md-6 col-sm-12">
                            <form-date-input v-model="vm.StartDay" id="StartDay" label="日期(起)" required></form-date-input>
                        </div>
                        <div class="col-md-6 col-sm-12">
                            <form-input v-model="vm.StartTime" id="StartTime" label="時間(起)" type="time" required></form-input>
                        </div>
                        <div class="col-md-6 col-sm-12">
                            <form-date-input v-model="vm.EndDay" id="EndDay" label="日期(訖)" required></form-date-input>
                        </div>
                        <div class="col-md-6 col-sm-12">
                            <form-input v-model="vm.EndTime" id="EndTime" label="時間(訖)" type="time" required></form-input>
                        </div>
                    </div>
                </div>

                <div class="card mb-1">
                    <div class="card-header">
                        活動地點
                    </div>
                    <div class="card-body row">
                        <div class="col-md-1 col-sm-12">
                            <div class="form-group">
                                <label>校內</label>
                                <label class="form-control">
                                    <input type="checkbox" v-model="vm.OnCampus" value="true" />
                                </label>
                            </div>
                        </div>
                        <div class="col-md-11 col-sm-12">
                            <form-input v-model="vm.Place" id="Place" label="地點" type="text" required></form-input>
                        </div>
                    </div>
                </div>

                <div class="card mb-1">
                    <div class="card-header">
                        辦理社團
                    </div>
                    <div class="card-body row">
                        <div class="col-md-6 col-sm-12">
                            <form-select v-model="vm.Property" id="Property" label="屬性" @change="propertyChange">
                                <div is="option" value="">全部</div>
                                <div is="option" v-for="item in Propertys" :key="item.key" :value="item.key">{{item.value}}</div>
                            </form-select>
                        </div>
                        <div class="col-md-6 col-sm-12">
                            <form-select v-model="vm.CommunityID" id="CommunityID" label="社團" required>
                                <div is="option" value="">請選擇</div>
                                <div is="option" v-for="item in CommunitysFilter" :key="item.key" :value="item.key">{{item.value}}</div>
                            </form-select>
                        </div>
                        <div class="col-12">
                            <form-input v-model="vm.StudentNo" id="StudentNo" label="負責人學號" type="text" student required></form-input>
                        </div>
                    </div>
                </div>

                <div class="card mb-1">
                    <div class="card-header">
                        人數
                    </div>
                    <div class="card-body row">
                        <div class="col-md-3 col-sm-12">
                            <form-input v-model="vm.Preliminary" id="Preliminary" label="提案人數" type="number" required></form-input>
                        </div>
                        <div class="col-md-3 col-sm-12">
                            <form-input v-model="vm.CaseClosed" id="CaseClosed" label="結案人數" type="number"></form-input>
                        </div>
                        <div class="col-md-3 col-sm-12">
                            <form-input v-model="vm.Teachers" id="Teachers" label="師長人數" type="number"></form-input>
                        </div>
                        <div class="col-md-3 col-sm-12">
                            <form-input v-model="vm.Outside" id="Outside" label="外校人數" type="number"></form-input>
                        </div>
                    </div>
                </div>

                <div class="card mb-1">
                    <div class="card-body row">
                        <div class="col-md-6 col-sm-12">
                            <form-input v-model="vm.Cross" id="Cross" label="跨校合作單位" type="text"></form-input>
                        </div>
                        <div class="col-md-6 col-sm-12">
                            <form-input v-model="vm.Service" id="Service" label="服務學習時數" type="number"></form-input>
                        </div>
                        <div class="col-12">
                            <form-textarea v-model="vm.Remark" id="Remark" label="備註" type="text"></form-textarea>
                        </div>
                    </div>
                </div>
            </b-collapse>

            <b-button class="mb-1" block v-b-toggle.accordion-2>補助金額</b-button>
            <b-collapse id="accordion-2" accordion="my-accordion" role="tabpanel">
                <div class="card mb-1">
                    <div class="card-header">
                        學輔款
                    </div>
                    <div class="card-body row">
                        <div class="col-md-6 col-sm-12">
                            <form-input v-model="vm.SubsidyNumber1" id="SubsidyNumber1" label="編號" type="text"></form-input>
                        </div>
                        <div class="col-md-6 col-sm-12">
                            <form-input v-model="vm.SubsidyAmount1" id="SubsidyAmount1" label="金額" type="number"></form-input>
                        </div>
                    </div>
                </div>
                <div class="card mb-1">
                    <div class="card-header">
                        整體發展獎補助款
                    </div>
                    <div class="card-body row">
                        <div class="col-md-6 col-sm-12">
                            <form-input v-model="vm.SubsidyNumber2" id="SubsidyNumber2" label="編號" type="text"></form-input>
                        </div>
                        <div class="col-md-6 col-sm-12">
                            <form-input v-model="vm.SubsidyAmount2" id="SubsidyAmount2" label="金額" type="number"></form-input>
                        </div>
                    </div>
                </div>
                <div class="card mb-1">
                    <div class="card-header">
                        課外組預算
                    </div>
                    <div class="card-body row">
                        <div class="col-md-6 col-sm-12">
                            <form-input v-model="vm.SubsidyNumber3" id="SubsidyNumber3" label="編號" type="text"></form-input>
                        </div>
                        <div class="col-md-6 col-sm-12">
                            <form-input v-model="vm.SubsidyAmount3" id="SubsidyAmount3" label="金額" type="number"></form-input>
                        </div>
                    </div>
                </div>
                <div class="card mb-1">
                    <div class="card-header">
                        其他
                    </div>
                    <div class="card-body row">
                        <div class="col-md-6 col-sm-12">
                            <form-input v-model="vm.SubsidyNumber4" id="SubsidyNumber4" label="編號" type="text"></form-input>
                        </div>
                        <div class="col-md-6 col-sm-12">
                            <form-input v-model="vm.SubsidyAmount4" id="SubsidyAmount4" label="金額" type="number"></form-input>
                        </div>
                    </div>
                </div>
            </b-collapse>

            <b-button class="mb-1" block v-b-toggle.accordion-3>經費執行</b-button>
            <b-collapse id="accordion-3" accordion="my-accordion" role="tabpanel">
                <div class="row">
                    <div class="col-md-6 col-sm-12">
                        <form-input v-model="vm.Budget" id="Budget" label="預算" type="text"></form-input>
                    </div>
                    <div class="col-md-6 col-sm-12">
                        <form-input v-model="vm.FinalAccounts" id="FinalAccounts" label="決算" type="number"></form-input>
                    </div>
                </div>
            </b-collapse>

            <b-button class="mb-1" block v-b-toggle.accordion-4>提案-UCAN核心能力（軟實力）</b-button>
            <b-collapse id="accordion-4" accordion="my-accordion" role="tabpanel">
                <div class="row">
                    <div class="col-md-3 col-sm-12">
                        <div class="form-group">
                            <label class="form-control">
                                <input type="checkbox" v-model="vm.UCAN1" value="true" />表達溝通
                            </label>
                        </div>
                    </div>
                    <div class="col-md-3 col-sm-12">
                        <div class="form-group">
                            <label class="form-control">
                                <input type="checkbox" v-model="vm.UCAN2" value="true" />持續學習
                            </label>
                        </div>
                    </div>
                    <div class="col-md-3 col-sm-12">
                        <div class="form-group">
                            <label class="form-control">
                                <input type="checkbox" v-model="vm.UCAN3" value="true" />情緒管理
                            </label>
                        </div>
                    </div>
                    <div class="col-md-3 col-sm-12">
                        <div class="form-group">
                            <label class="form-control">
                                <input type="checkbox" v-model="vm.UCAN4" value="true" />人際互動
                            </label>
                        </div>
                    </div>
                    <div class="col-md-3 col-sm-12">
                        <div class="form-group">
                            <label class="form-control">
                                <input type="checkbox" v-model="vm.UCAN5" value="true" />團隊合作
                            </label>
                        </div>
                    </div>
                    <div class="col-md-3 col-sm-12">
                        <div class="form-group">
                            <label class="form-control">
                                <input type="checkbox" v-model="vm.UCAN6" value="true" />問題解決
                            </label>
                        </div>
                    </div>
                    <div class="col-md-3 col-sm-12">
                        <div class="form-group">
                            <label class="form-control">
                                <input type="checkbox" v-model="vm.UCAN7" value="true" />積極創新
                            </label>
                        </div>
                    </div>
                    <div class="col-md-3 col-sm-12">
                        <div class="form-group">
                            <label class="form-control">
                                <input type="checkbox" v-model="vm.UCAN8" value="true" />紀律責任
                            </label>
                        </div>
                    </div>
                </div>
            </b-collapse>

            <b-button class="mb-1" block v-b-toggle.accordion-5>提案-校核心素養</b-button>
            <b-collapse id="accordion-5" accordion="my-accordion" role="tabpanel">
                <div class="row">
                    <div class="col-md-3 col-sm-12">
                        <div class="form-group">
                            <label class="form-control">
                                <input type="checkbox" v-model="vm.Core1" value="true" />道德思辨
                            </label>
                        </div>
                    </div>
                    <div class="col-md-3 col-sm-12">
                        <div class="form-group">
                            <label class="form-control">
                                <input type="checkbox" v-model="vm.Core2" value="true" />團隊合作
                            </label>
                        </div>
                    </div>
                    <div class="col-md-3 col-sm-12">
                        <div class="form-group">
                            <label class="form-control">
                                <input type="checkbox" v-model="vm.Core3" value="true" />行動實踐
                            </label>
                        </div>
                    </div>
                    <div class="col-md-3 col-sm-12">
                        <div class="form-group">
                            <label class="form-control">
                                <input type="checkbox" v-model="vm.Core4" value="true" />專業知識
                            </label>
                        </div>
                    </div>
                    <div class="col-md-3 col-sm-12">
                        <div class="form-group">
                            <label class="form-control">
                                <input type="checkbox" v-model="vm.Core5" value="true" />獨立思考
                            </label>
                        </div>
                    </div>
                    <div class="col-md-3 col-sm-12">
                        <div class="form-group">
                            <label class="form-control">
                                <input type="checkbox" v-model="vm.Core6" value="true" />追根究底
                            </label>
                        </div>
                    </div>
                    <div class="col-md-3 col-sm-12">
                        <div class="form-group">
                            <label class="form-control">
                                <input type="checkbox" v-model="vm.Core7" value="true" />公民意識
                            </label>
                        </div>
                    </div>
                    <div class="col-md-3 col-sm-12">
                        <div class="form-group">
                            <label class="form-control">
                                <input type="checkbox" v-model="vm.Core8" value="true" />多元價值
                            </label>
                        </div>
                    </div>
                    <div class="col-md-3 col-sm-12">
                        <div class="form-group">
                            <label class="form-control">
                                <input type="checkbox" v-model="vm.Core9" value="true" />國際視野
                            </label>
                        </div>
                    </div>
                </div>
            </b-collapse>

            <b-button class="mb-1" block v-b-toggle.accordion-6>結案-UCAN核心能力（軟實力）</b-button>
            <b-collapse id="accordion-6" accordion="my-accordion" role="tabpanel">
                <div class="row">
                    <div class="col-12">
                        <form-input v-model="vm.EndUCAN" id="EndUCAN" label="總分" type="number"></form-input>
                    </div>
                    <div class="col-12">
                        <form-input v-model="vm.EndUCAN1" id="EndUCAN1" label="表達溝通" type="number"></form-input>
                    </div>
                    <div class="col-12">
                        <form-input v-model="vm.EndUCAN2" id="EndUCAN2" label="持續學習" type="number"></form-input>
                    </div>
                    <div class="col-12">
                        <form-input v-model="vm.EndUCAN3" id="EndUCAN3" label="情緒管理" type="number"></form-input>
                    </div>
                    <div class="col-12">
                        <form-input v-model="vm.EndUCAN4" id="EndUCAN4" label="人際互動" type="number"></form-input>
                    </div>
                    <div class="col-12">
                        <form-input v-model="vm.EndUCAN5" id="EndUCAN5" label="團隊合作" type="number"></form-input>
                    </div>
                    <div class="col-12">
                        <form-input v-model="vm.EndUCAN6" id="EndUCAN6" label="問題解決" type="number"></form-input>
                    </div>
                    <div class="col-12">
                        <form-input v-model="vm.EndUCAN7" id="EndUCAN7" label="積極創新" type="number"></form-input>
                    </div>
                    <div class="col-12">
                        <form-input v-model="vm.EndUCAN8" id="EndUCAN8" label="紀律責任" type="number"></form-input>
                    </div>
                </div>
            </b-collapse>

            <b-button class="mb-1" block v-b-toggle.accordion-9 @click="show">報到</b-button>
            <b-collapse id="accordion-9" accordion="my-accordion" role="tabpanel" v-if="isedit">
                <table class="table">
                    <thead>
                        <tr>
                            <th>學號/教師編號</th>
                            <th>姓名</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tr v-for="item in tableData.value" :key="item.ActivityRegisterID">
                        <td>{{item.UserNo}}</td>
                        <th>{{item.Name}}</th>
                        <th>
                            <b-button variant="danger" @click="deltemp(item.ActivityRegisterID)">刪除</b-button>
                        </th>
                    </tr>
                    <tr>
                        <td data-th="學號/教師編號">
                            <input v-model="temp.UserNo" type="text" class="form-control" />
                        </td>
                        <td data-th="姓名">
                            <input v-model="temp.Name" type="text" class="form-control" />
                        </td>
                        <td>
                            <div class="form-group">
                                <b-button variant="primary" @click="savetemp">儲存</b-button>
                            </div>
                        </td>
                    </tr>
                </table>
                <pagination v-model="pager" :rows="tableData.count" :rowperpage="10" @paging="load"></pagination>
            </b-collapse>
        </div>
    </modal>
</template>

<script>
    import { detail } from '@/views';
    export default detail({
        name: 'communityactivityDetail',
        api: '/api/communityactivity/',
        data: {
            Propertys: [], Communitys: [],
            tableData: { count: 0, value: [] },
            pager: {},
            temp: { No: null, UserNo: '', Name: '' }
        },
        vm: { Name: '', Place: '', Property: '' },
        created: function () {
            this.$parameter.communityproperty().then((res) => { this.Propertys = res.data; });
            this.$parameter.community().then((res) => { this.Communitys = res.data; });
        },
        computed: {
            CommunitysFilter: function () {
                return this.vm.Property == "" ? this.Communitys : this.Communitys.filter(x => x.Property == this.vm.Property);
            }
        },
        methods: {
            propertyChange: function () {
                this.vm.CommunityID = "";
            },
            show: function () {
                if (this.isedit) {
                    this.reload();
                    return
                } else {
                    this.$bvToast.toast('請先儲存活動', { title: '發生錯誤', variant: 'warning', solid: true });
                }
            },
            load: function () {
                return this.$http({ method: 'get', url: 'api/activityregister/Get?No=' + this.vm.No, headers: this.pager })
                    .then(res => {
                        if (res.data) {
                            this.tableData.count = res.data.count;
                            this.tableData.value = res.data.value;
                        } else {
                            this.tableData.count = 0;
                            this.tableData.value = [];
                        }
                    });
            },
            reload: function () {
                this.pager.skip = 0;
                return this.load();
            },
            savetemp: function () {
                this.temp.No = this.vm.No;
                this.$http({ method: 'put', url: 'api/activityregister/Put', data: this.temp })
                    .then(() => { this.reload(); });
            },
            deltemp: function (ActivityRegisterID) {
                this.$http({ method: 'delete', url: 'api/activityregister/Delete/' + ActivityRegisterID })
                    .then(() => { this.reload(); })
            },
            getActive: function () {
                if (this.vm.No) {
                    let vue = this.vm;
                    this.$http({ method: 'get', url: 'api/active/Data/' + this.vm.No })
                        .then((res) => {
                            if (res.data) {
                                vue.Name = res.data.name;
                                vue.Place = res.data.place;
                            } else {
                                this.$bvToast.toast('查無資料', { title: '發生錯誤', variant: 'danger', solid: true });
                            }
                        })
                } else {
                    this.$bvToast.toast('請輸入活動編號', { title: '發生錯誤', variant: 'danger', solid: true });
                }
            }
        }
    });
</script>

<style>
</style>